// extracted by mini-css-extract-plugin
export default {"pageIconStyle":"emptyState_pageIconStyle__BvHwA","primaryActionBtnSpacing":"emptyState_primaryActionBtnSpacing__xFiye"};